import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import styled from 'styled-components';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin-left: 6px;
`;

/**
 * ValidationBadge
 * Chip showing count of overlapping subtitles.
 * Updates automatically as overlaps are fixed.
 * Props:
 *   subtitle  — subtitle array
 *   checkSub  — function(sub) → true if sub has a timing violation
 */
export default function ValidationBadge({ subtitle, checkSub }) {
    if (!subtitle || subtitle.length === 0) return null;

    const overlapCount = subtitle.filter((s) => checkSub(s)).length;

    if (overlapCount === 0) return null;

    return (
        <Wrapper>
            <Tooltip
                title={`${overlapCount} subtitle${overlapCount !== 1 ? 's' : ''} have timing overlaps.`}
                arrow
            >
                <Chip
                    icon={<WarningAmberIcon />}
                    label={`${overlapCount} overlap${overlapCount !== 1 ? 's' : ''}`}
                    color="warning"
                    size="small"
                    sx={{
                        fontWeight: 600,
                        fontSize: '0.72rem',
                        '& .MuiChip-icon': { fontSize: 16 },
                    }}
                />
            </Tooltip>
        </Wrapper>
    );
}
